import {defaultKeywords} from "../keywords";

export const seoContentMapDe = {
    '/': {
        title: "Rodin - Kostenloser KI-3D-Modellgenerator aus Bildern | Hyper3D",
        description: "Erstellen Sie in Sekunden beeindruckende 3D-Modelle mithilfe von KI. Generieren Sie kinderleicht 3D-Modelle aus Text oder Bildern und revolutionieren Sie noch heute Ihren kreativen Prozess.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Kostenloser KI-3D-Modellgenerator mit Text und Bild",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin': {
        title: "Rodin - Kostenloser KI-3D-Modellgenerator | Hyper3D",
        description: "Erstellen Sie in Sekundenschnelle beeindruckende 3D-Modelle mithilfe von KI. Generieren Sie problemlos 3D-Modelle aus Text oder Bildern und bringen Sie Ihren kreativen Prozess auf das nächste Level!",
        keywords: defaultKeywords,
        h1Text: "Rodin - Kostenloser KI-3D-Modellgenerator mit Text und Bild",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/"
    },
    '/rodin/page': {
        title: "Rodin - KI-3D-Modellgenerator",
        description: "Erstellen Sie in Sekundenschnelle beeindruckende 3D-Modelle mithilfe von KI. Generieren Sie problemlos 3D-Modelle aus Text oder Bildern und bringen Sie Ihren kreativen Prozess auf ein neues Niveau!",
        keywords: defaultKeywords,
        h1Text: "Rodin - Kostenloser KI-3D-Modellgenerator mit Text und Bild",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
    },
    '/rodin/search': {
        title: "3D-Modelle | Hyper3D",
        description: "Fertig zum Betrachten und kostenloser Download in fbx, obj, glb und usd. Ideal für Spiele, VR/AR, Videoproduktion und 3D-Druck.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Kostenloser KI-3D-Modellgenerator mit Text und Bild",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
    },
    '/rodin/tab/story': {
        title: "Rodin - Benutzergeschichten-Kollektion | Hyper3D",
        description: "Entdecken Sie eine Vielzahl von Anwendungsbeispielen und erfahren Sie, wie Rodin den kreativen Prozess für Künstler und Designer verändert.",
        keywords: defaultKeywords,
        h1Text: "Rodin - Kostenloser KI-3D-Modellgenerator mit Text und Bild",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/rodin/tab/story"
    },
    '/chatavatar': {
        title: "ChatAvatar - KI-3D-Gesichtsassets-Generator | Hyper3D",
        description: "ChatAvatar von Hyper3D erstellt in wenigen Minuten hyperrealistische 3D-Gesichtsassets mit PBR-Texturen aus Text oder Bildern.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3D-Gesichtsassets-Generator",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/imageto3d': {
        title: "ChatAvatar - KI-3D-Gesichtsassets-Generator | Hyper3D",
        description: "ChatAvatar von Deemos Hyper3D erstellt in wenigen Minuten hyperrealistische 3D-Gesichtsassets mit PBR-Texturen aus Text oder Bildern.",
        keywords: defaultKeywords,
        h1Text: "ChatAvatar - 3D-Gesichtsassets-Generator",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/chatavatar"
    },
    '/subscribe': {
        title: "Preisgestaltung | Hyper3D",
        description: "Abonnieren Sie Hyper3D, um Zugriff auf exklusive Funktionen und Inhalte zu erhalten.",
        keywords: defaultKeywords + "Subscription, Hyper3D, Premium, Features",
        h1Text: "Abonnement - Hyper3D",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/subscribe"
    },
    '/api-dashboard': {
        title: "API-Dashboard | Hyper3D",
        description: "Verwalten Sie Ihre Hyper3D-API-Schlüssel und überwachen Sie Nutzungsstatistiken.",
        keywords: defaultKeywords + "API, Dashboard, Hyper3D, API Keys, Usage",
        h1Text: "API-Dashboard",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/api-dashboard"
    },
    '/user/login': {
        title: "Login | Hyper3D",
        description: "Greifen Sie auf Ihr Hyper3D-Konto zu. Kostenlose Nutzung. Einfacher Einstieg. Stellen Sie Ihre Anfrage und Hyper3D unterstützt Sie beim Modellieren, Texturieren und mehr.",
        keywords: defaultKeywords + "Login, Hyper3D, User, Account",
        h1Text: "Login",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/user/login"
    },
    '/signup': {
        title: "Registrieren | Hyper3D",
        description: "Erstellen Sie ein neues Hyper3D-Konto. Kostenlose Nutzung. Einfacher Einstieg. Stellen Sie Ihre Anfrage und Hyper3D unterstützt Sie beim Modellieren, Texturieren und mehr.",
        keywords: defaultKeywords + "Sign Up, Hyper3D, Register, Account",
        h1Text: "Registrieren",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/signup"
    },
    '/legal/privacy': {
        title: "Datenschutzrichtlinie | Hyper3D",
        description: "Lesen Sie die Datenschutzrichtlinie von Hyper3D, um zu erfahren, wie wir Ihre Daten behandeln.",
        keywords: defaultKeywords + "Privacy Policy, Hyper3D, Data Protection, Privacy",
        h1Text: "Datenschutzrichtlinie",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/privacy"
    },
    '/legal/terms': {
        title: "Nutzungsbedingungen | Hyper3D",
        description: "Lesen Sie die Nutzungsbedingungen von Hyper3D. Diese Bedingungen regeln die Erstellung mit den Hyper3D-Diensten.",
        keywords: defaultKeywords + "Terms of Service, Hyper3D, Terms, Conditions",
        h1Text: "Nutzungsbedingungen",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/legal/terms"
    },
    '/product/faq': {
        title: "Häufig gestellte Fragen | Hyper3D",
        description: "Hier finden Sie Antworten auf häufige Fragen zu den Produkten und Dienstleistungen von Hyper3D.",
        keywords: defaultKeywords + "FAQ, Hyper3D, Questions, Answers, Help",
        h1Text: "Häufig gestellte Fragen",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/product/faq"
    },
    '/omnicraft': {
        title: "OmniCraft - 3D-Toolbox | Hyper3D",
        description: "Omnicraft ist eine kostenlose Online-3D-Modellierungstoolbox für 3D-Künstler, Spieleentwickler, Designer und mehr.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, omnicraft",
        h1Text: "Erschaffen Sie Ihre eigene virtuelle Welt aus Bildern, Text und Fantasie",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/"
    },
    '/omnicraft/hdri': {
        title: "HDRI-Panoramagenerator – Bauen Sie Ihre eigene virtuelle Welt | Hyper3D",
        description: "Erstellen Sie mit unserem HDRI-Panoramagenerator in Sekunden Ihre eigene virtuelle Welt. Aus Bild, Text und Fantasie.",
        keywords: defaultKeywords + "HDRI Generator, image generator, image creator, panorama generator, skybox generator",
        h1Text: "Erschaffen Sie Ihre eigene virtuelle Welt aus Bildern, Text und Fantasie",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/hdri"
    },
    '/omnicraft/formatcon': {
        title: "3D-Formatkonverter – Kostenlos und vollständig offline | Hyper3D",
        description: "Ziehen Sie einfach Ihre 3D-Modelldatei per Drag & Drop, um sie in gängige Formate wie obj, fbx, gltf, glb und usd zu konvertieren. Kostenlose Nutzung und vollständig offline.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Kostenloser, sicherer und vollständig offline 3D-Modellkonverter",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/formatcon"
    },
    '/omnicraft/mesh': {
        title: "3D-Mesh-Sculpting – Kostenlos und vollständig offline | Hyper3D",
        description: "Ein 3D-Mesh-Sculpting-Tool, das alle gängigen Formate wie obj, fbx, 3ds, dxf, glb und usd unterstützt. Kostenlose Nutzung und vollständig offline.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Kostenloser, sicherer und vollständig offline 3D-Modellkonverter",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/mesh"
    },
    '/omnicraft/search': {
        title: "Rodin-Suche – 3D-Modell-Suchmaschine | Hyper3D",
        description: "3D-Suchmaschine, mit der Sie 3D-Modelle von Sketchfab, Daz3D und Rodin anhand von Bildern, Text oder dem 3D-Modell selbst schnell finden können.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Rodin-Suche – 3D-Modell-Suchmaschine",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/search"
    },
    '/omnicraft/viewer': {
        title: "3D-Modell-Viewer – Kostenlos und vollständig offline | Hyper3D",
        description: "Ein 3D-Modell-Viewer, der gängige Formate wie obj, fbx, stl, gltf, 3ds, dxf, ply, glb und usd unterstützt.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Kostenloser, sicherer und vollständig offline 3D-Modell-Viewer",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/viewer"
    },
    '/omnicraft/texture': {
        title: "3D-Texturgenerator – 3D-Textur aus Bildern | Hyper3D",
        description: "Ein KI-Texturgenerator, mit dem jeder realistische Texturen aus Bildern erstellen kann, um Modelle, Spiele, AR/VR und Kunst zum Leben zu erwecken.",
        keywords: defaultKeywords + "obj, fbx, stl, gltf, dar, 3ds, dxf, ply, glb, usd",
        h1Text: "Kostenloser, sicherer und vollständig offline 3D-Texturgenerator",
        image: "https://hyper3d.ai/assets/og-banner.webp",
        atl: "Hyper3D - Revolutionieren Sie die 3D-Modellierung mit Rodin & ChatAvatar",
        canonicalUrl: "https://hyper3d.ai/omnicraft/texture"
    },
}